import { RouteComponentProps, Switch } from 'react-router-dom';

import AuthenticatedPrivateRoute from '../../../AuthenticatedPrivateRoute';
import { MatchParam } from '../../../common/types';
import OnpremDatabaseCost from './on-prem-database-cost/OnpremDatabaseCost';
import OnpremITLaborCost from './on-prem-it-labor-cost/OnpremITLaborCost';
import OnpremServerCost from './on-prem-server-cost/OnpremServerCost';
import OnpremStorageNetworkCost from './on-prem-storage-and-network-cost/OnpremStorageNetworkCost';

type OnPremisesPagesProps = RouteComponentProps<MatchParam>;

function OnPremisesPage(props: OnPremisesPagesProps) {
    const { path } = props.match;

    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/server-costs`} component={OnpremServerCost}/>
            <AuthenticatedPrivateRoute path={`${path}/database-costs`} component={OnpremDatabaseCost} />
            <AuthenticatedPrivateRoute path={`${path}/storage-network-costs`} component={OnpremStorageNetworkCost} />
            <AuthenticatedPrivateRoute path={`${path}/it-labor-costs`} component={OnpremITLaborCost} />
        </Switch>
    );
}

export default OnPremisesPage;
